export default __webpack_public_path__ + "c7c81c2d01df42c7ff516d489406cbdb.svg";